import React from 'react';
import { push } from "connected-react-router";
import { bindActionCreators } from 'redux'
import { connect } from "react-redux";
import {login} from '../../modules/user';
const Loader = require('react-loaders').Loader;


class Login extends React.Component {
    constructor() {
        super();
        this.state = {
            username:'',
            password:'',
            error:'',
            isLoading:false
        }
    }
    render() {
        return <div className={"login-wrapper"}>
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-md-4"}>
                         <div className={"loginlogo"}>
                             <div className={"loginname"}>Social gateway</div>
                         </div>
                    </div>
                    <div className={"col-md-4"}>
                        <div className={"login"}>
                            {this.state.isLoading && !this.props.messages.error ?
                                <div><i class="outer-circle"></i><i class="inner-circle"></i></div>
                                :
                                <div>
                                    <div className={"error"}>{this.props.messages.error}</div>
                                    <h3>Please sign in</h3>
                                    <input className={"logonbox"} placeholder={"Username"} onChange={(e) => this.setState({username:e.target.value})}/>
                                    <input className={"logonbox"} placeholder={"Password"} type="password" onChange={(e) => this.setState({password: e.target.value})}/>
                                    <input type="submit" className={"custombutton"} value={"Log in"} onClick={(e) => {
                                        this.setState({isLoading:true});
                                        this.props.login({username:this.state.username, password:this.state.password})
                                    }}
                                    />
                                    <a href={"https://www.edialog24.no/sikkerhet-og-personvern/"}>Sikkerhet og personvern</a>
                                </div>
                            }
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                    </div>
                </div>
            </div>
        </div>
    }
}


const mapStateToProps = ({messages}) => ({
    messages
})
const mapDispatchToProps = dispatch => bindActionCreators({
    login,
    gotoHome: () => push('/home'),
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login)


// WEBPACK FOOTER //
// ./src/containers/login/index.js